import { useRouteParam } from "@/shared/routing/useRouteParam.ts";
import type { ScheduleRange } from "@/pages/human-resources/time-management/model/ScheduleRange.ts";

export default function useScheduleRangeOnRoute(): ScheduleRange {
  return useRouteParam("range").toUpperCase() as ScheduleRange;
}
